// removed by extract-text-webpack-plugin
module.exports = {"select":"G8IVHH165LAz5-T9DZ1r3","chartjsTooltip":"_1B5PRts8ZuBxEuFqEPZAzz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisChart.scss
// module id = 1199
// module chunks = 0